import type IFeature from '@/common/models/IFeature'
import type {Permission} from '@/common/services/Feature/featureFactory'
import {FeaturePermissions} from '@/common/factory/FeatureFactory/FeaturePermissions'
import {SingletonService} from '@/common/dependency.configs'
import {injectable} from 'inversify'

@SingletonService
@injectable()
export class FeaturesFromPermissionsFactory {

  constructor() {}

  private makeFeature(featureCode: String): IFeature {
    return {
      featureCode,
      parentFeatureCode: '',
      hasChildren: false,
      app_code: 'any',
    } as IFeature
  }

  make(permissions: Permission[]): IFeature[] {

    const userPermissions = new Set(permissions.map((permission) => permission.PermissionName))

    const userAllowedFeatures = Object.entries(FeaturePermissions)
      .filter(([_, featurePermission]) => featurePermission.some((permission) => userPermissions.has(permission)))
      .map(([featureCode, _]) => featureCode)

    return userAllowedFeatures.map((featureCode) => this.makeFeature(featureCode))

  }

}
